import { useSelector } from 'react-redux';

import { Types } from '@store/types';

const initialState = {
	preferences: null,
	exploreProductsSourceType: 'BRAND',
	trendInsightSummary: {},
	selectedDateRange: {},
	selectedPreferences: {
		categoryResponseList: [],
		productGroupResponseList: [],
		fabricTypeList: []
	},
	selectedBrands: [],
	selectedIncluencers: [],
	brandList: [],
	influencerList: [],
	selectedMoodboard: null,
	allMoodboards: []
};

const TrendResearchReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_ALL_TREND_RESEARCH_BRAND_LIST:
			return {
				...state,
				brandList: action.payload
			};
		case Types.SAVE_TREND_RESEARCH_USER_PREFERENCE: {
			let selectedPreference = {};
			const trendResearchSelectedPreference = localStorage.getItem('trendResearchSelectedPreference');
			if (trendResearchSelectedPreference) {
				let parsedPreference = JSON.parse(trendResearchSelectedPreference);
				selectedPreference = { ...parsedPreference };
			} else {
				selectedPreference = {
					productGroupResponseList: action.payload.productGroupResponseList?.map((item) => item.id),
					categoryResponseList: action.payload.categoryResponseList?.map((item) => item.id),
					fabricTypeList: action.payload.fabricTypeList?.map((item) => item.constant)
				};
				localStorage.setItem('trendResearchSelectedPreference', JSON.stringify(selectedPreference));
			}
			return {
				...state,
				preferences: action.payload,
				selectedPreferences: {
					...state.selectedPreferences,
					...selectedPreference
				}
			};
		}
		case Types.SET_SELECTED_PREFERENCE_FOR_FILTER: {
			const { preferenceType, selectedId } = action.payload;
			const currentPreference = state.selectedPreferences[preferenceType] || [];

			const updatedPreference = currentPreference.includes(selectedId)
				? currentPreference.filter((id) => id !== selectedId)
				: [...currentPreference, selectedId];

			const selectedPreference = {
				...state.selectedPreferences,
				[preferenceType]: updatedPreference
			};
			localStorage.setItem('trendResearchSelectedPreference', JSON.stringify(selectedPreference));
			return {
				...state,
				trendInsightSummary: {},
				selectedPreferences: selectedPreference
			};
		}
		case Types.SET_DEFAULT_SELECTED_PREFERENCE_FOR_FILTER: {
			const { preferenceType, selectedIds, isResetSummary } = action.payload;
			const updatedPreference = [...selectedIds];
			const selectedPreference = {
				...state.selectedPreferences,
				[preferenceType]: updatedPreference
			};
			localStorage.setItem('trendResearchSelectedPreference', JSON.stringify(selectedPreference));
			return {
				...state,
				trendInsightSummary: isResetSummary ? {} : state.trendInsightSummary,
				selectedPreferences: selectedPreference
			};
		}
		case Types.TOGGLE_BOTH_MARKET_AND_FABRIC_TYPES: {
			const selectedPreference = {
				...state.selectedPreferences,
				productGroupResponseList: action.payload.productGroupResponseList,
				fabricTypeList: action.payload.fabricTypeList
			};
			localStorage.setItem('trendResearchSelectedPreference', JSON.stringify(selectedPreference));
			return {
				...state,
				trendInsightSummary: action.payload.isResetSummary ? {} : state.trendInsightSummary,
				selectedPreferences: selectedPreference
			};
		}
		case Types.SET_SELECTED_BRANDS_FOR_FILTER: {
			const { selectedCode } = action.payload;
			let cloneBrandIds = [...state.selectedBrands];
			if (cloneBrandIds.includes(selectedCode)) {
				cloneBrandIds = cloneBrandIds.filter((code) => code !== selectedCode);
			} else {
				cloneBrandIds.push(selectedCode);
			}

			return {
				...state,
				trendInsightSummary: {},
				selectedBrands: cloneBrandIds
			};
		}
		case Types.SET_MULTIPLE_SELECTED_BRANDS_FOR_FILTER: {
			const { selectedCodes } = action.payload;
			let cloneBrandIds = [...state.selectedBrands];

			for (let selectedCode of selectedCodes) {
				if (cloneBrandIds.includes(selectedCode)) {
					cloneBrandIds = cloneBrandIds.filter((code) => code !== selectedCode);
				} else {
					cloneBrandIds.push(selectedCode);
				}
			}
			return {
				...state,
				trendInsightSummary: {},
				selectedBrands: cloneBrandIds
			};
		}
		case Types.SET_ALL_BRANDS_FOR_FILTER: {
			const { selectedCodes } = action.payload;
			return {
				...state,
				trendInsightSummary: {},
				selectedBrands: selectedCodes
			};
		}
		case Types.SET_BRAND_INSIGHT_SUMMARY: {
			return {
				...state,
				trendInsightSummary: action.payload
			};
		}
		case Types.SET_EXPLORE_PRODUCTS_SOURCE_TYPE: {
			return {
				...state,
				exploreProductsSourceType: action.payload
			};
		}
		case Types.SET_ALL_INSTAGRAM_INFLUENCER: {
			return {
				...state,
				influencerList: action.payload
			};
		}
		case Types.SELECT_ALL_INSTAGRAM_INFLUENCER: {
			return {
				...state,
				trendInsightSummary: {},
				selectedIncluencers: action.payload
			};
		}
		case Types.TOGGLE_INSTAGRAM_INFLUENCER: {
			let cloneUserNames = [...state.selectedIncluencers];
			if (cloneUserNames.includes(action.payload)) {
				cloneUserNames = cloneUserNames.filter((userName) => userName !== action.payload);
			} else {
				cloneUserNames.push(action.payload);
			}

			return {
				...state,
				trendInsightSummary: {},
				selectedIncluencers: cloneUserNames
			};
		}
		case Types.SET_SINGLE_MOODBOARD: {
			return {
				...state,
				selectedMoodboard: action.payload
			};
		}
		case Types.SET_ALL_MOODBOARD: {
			return {
				...state,
				allMoodboards: action.payload
			};
		}
		case Types.SET_TREND_RESEARCH_FILTER_CALENDAR: {
			return {
				...state,
				trendInsightSummary: {},
				selectedDateRange: action.payload ? JSON.parse(JSON.stringify(action.payload)) : {}
			};
		}
		default:
			return { ...state };
	}
};

export const useTrendResearchPreference = () => useSelector((state) => state.trendResearchStore.preferences);

export const useTrendResearchOnboardedBrands = () =>
	useSelector((state) => state.trendResearchStore.brandList);

export const useInstagramInfluencer = () => useSelector((state) => state.trendResearchStore.influencerList);

export const useSelectedPreferences = () =>
	useSelector((state) => state.trendResearchStore.selectedPreferences);

export const useSelectedBrands = () => useSelector((state) => state.trendResearchStore.selectedBrands);

export const useSelectedInluencers = () =>
	useSelector((state) => state.trendResearchStore.selectedIncluencers);

export const useInsightSummary = () => useSelector((state) => state.trendResearchStore.trendInsightSummary);

export const useExploreProductsSource = () =>
	useSelector((state) => state.trendResearchStore.exploreProductsSourceType);

export const useSelectedDateRange = () => useSelector((state) => state.trendResearchStore.selectedDateRange);

export default TrendResearchReducer;
